var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-regulatory-wrapper"},[_vm._t("default"),_c('sk-regulatory-footer',_vm._b({},'sk-regulatory-footer',{ userDevice: _vm.userDevice },false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }